<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('medal.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="c">
            <van-tabs
                v-model="activeType"
                title-active-color="var(--text-color-1)"
                title-inactive-color="var(--text-color-3)"
                line-height="2"
                background="var(--bg-color-1)"
                color="var(--text-color-1)"
            >
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('medal.tab0') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('medal.tab2') }}</div>
                    </template>
                </van-tab>
            </van-tabs>
            <div class="count-box">
                {{ $t('medal.get0') }}
                <span class="count-num" v-if="activeType == 0">{{ sportNum }}</span>
                <span class="count-num" v-if="activeType == 1">{{ challengeNum }}</span>
                {{ $t('medal.get1') }}
            </div>
            <div class="sport-box" v-if="activeType == 0">
                <div class="card">
                    <div class="card-title" @click="stepShow = !stepShow">{{ $t('medal.step') }}</div>
                    <img class="card-icon" v-if="stepShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="stepShow = !stepShow">
                    <img class="card-icon" v-if="stepShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="stepShow = !stepShow">
                    <div v-if="stepShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in stepMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="runShow = !runShow">{{ $t('medal.run') }}</div>
                    <img class="card-icon" v-if="runShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="runShow = !runShow">
                    <img class="card-icon" v-if="runShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="runShow = !runShow">
                    <div v-if="runShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in runMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="rideShow = !rideShow">{{ $t('medal.ride') }}</div>
                    <img class="card-icon" v-if="rideShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="rideShow = !rideShow">
                    <img class="card-icon" v-if="rideShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="rideShow = !rideShow">
                    <div v-if="rideShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in rideMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="swimShow = !swimShow">{{ $t('medal.swim') }}</div>
                    <img class="card-icon" v-if="swimShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="swimShow = !swimShow">
                    <img class="card-icon" v-if="swimShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="swimShow = !swimShow">
                    <div v-if="swimShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in swimMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="climbShow = !climbShow">{{ $t('medal.climb') }}</div>
                    <img class="card-icon" v-if="climbShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="climbShow = !climbShow">
                    <img class="card-icon" v-if="climbShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="climbShow = !climbShow">
                    <div v-if="climbShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in climbMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="marShow = !marShow">{{ $t('medal.marathon') }}</div>
                    <img class="card-icon" v-if="marShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="marShow = !marShow">
                    <img class="card-icon" v-if="marShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="marShow = !marShow">
                    <div v-if="marShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in marMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="card">
                    <div class="card-title" @click="sportShow = !sportShow">{{ $t('medal.sport') }}</div>
                    <img class="card-icon" v-if="sportShow==1" src="@/assets/theme/light/my/02medal/01down.png"
                         @click="sportShow = !sportShow">
                    <img class="card-icon" v-if="sportShow==0" src="@/assets/theme/light/my/02medal/02up.png"
                         @click="sportShow = !sportShow">
                    <div v-if="sportShow">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in durationMedalList" :key="index">
                                <div class="medal-item" @click="toDesc(item)">
                                    <img class="medal-url" v-if="item.awardTime"
                                         :src="item.medalLightPictureSvg">
                                    <img class="medal-url" v-if="!item.awardTime"
                                         :src="item.medalGloomyPicture">
                                    <div class="medal-title" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                                    <div class="medal-title" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
            <div class="challenge-box" v-if="activeType == 1">
                <div class="card" v-if="challengeMedal.length > 0">
                    <br>
                    <van-row>
                        <van-col span="8" v-for="(item, index) in challengeMedal" :key="index">
                            <div class="medal-item" @click="toDesc(item)">
                                <img class="medal-point-url"
                                     :src="item.url">
                                <div class="medal-title">{{ getName(item) }}</div>
                                <div class="medal-rank-title">{{
                                        $t('challengeDesc.no0')
                                    }}{{ item.rank }}{{ $t('challengeDesc.no1') }}
                                </div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="card" v-if="challengeMedal.length == 0">
                    <br>
                    <div class="no-data">
                        <div class="no-data-text">{{ $t('noData') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="showDesc">
            <div v-if="type == 0">
                <div :class="{'animation-box': true, 'animate': showAnimation}" @animationend="onAnimationEnd">
                    <img :src="item.medalLightPictureSvg" class="medel-img">
                </div>
                <div v-if="animationFinished" class="text-fade-in">
                    <div class="name" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                    <div class="name" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                    <div class="name" v-if="$i18n.locale == 'ja'">{{ item.medalNameJa }}</div>
                    <div class="desc" v-if="$i18n.locale == 'zh'">{{ item.medalDescription }}</div>
                    <div class="desc" v-if="$i18n.locale == 'en'">{{ item.medalDescriptionEn }}</div>
                    <div class="desc" v-if="$i18n.locale == 'ja'">{{ item.medalDescriptionJa }}</div>
                    <div class="time" v-if="item.awardTime">— {{ item.awardTime }} —</div>
                    <van-icon name="close" @click="closeDesc" size="36" color="var(--text-color-2)"/>
                </div>
            </div>
            <div v-if="type == 1">
                <div :class="{'animation-box': true, 'animate': showAnimation}" @animationend="onAnimationEnd">
                    <img :src="item.url" class="medel-img">
                </div>
                <div v-if="animationFinished" class="text-fade-in">
                    <div class="name">{{ getName(item) }}</div>
                    <div class="desc">{{ $t('challengeDesc.no0') }}{{ item.rank }}{{ $t('challengeDesc.no1') }}</div>
                    <div class="time" v-if="item.awardTime">— {{ item.awardTime }} —</div>
                    <van-icon name="close" @click="showDesc = 0" size="36" color="var(--text-color-2)"/>
                </div>
            </div>
        </div>
        <div class="content" v-if="showDescNotGet">
            <div v-if="type == 0">
                <div>
                    <img :src="item.medalGloomyPicture" class="medel-img">
                </div>
                <div>
                    <div class="name" v-if="$i18n.locale == 'zh'">{{ item.medalName }}</div>
                    <div class="name" v-if="$i18n.locale == 'en'">{{ item.medalNameEn }}</div>
                    <div class="name" v-if="$i18n.locale == 'ja'">{{ item.medalNameEn }}</div>
                    <div class="desc" v-if="$i18n.locale == 'zh'">{{ item.medalDescription }}</div>
                    <div class="desc" v-if="$i18n.locale == 'en'">{{ item.medalDescriptionEn }}</div>
                    <div class="desc" v-if="$i18n.locale == 'ja'">{{ item.medalDescriptionJa }}</div>
                    <van-icon class="close" name="close" @click="closeDesc" size="46" color="var(--text-color-2)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'medal',
    data() {
        return {
            showDesc: 0, // 已获得的勋章
            showDescNotGet: 0, // 没获得的勋章
            activeType: 0,
            sportNum: 0,
            stepShow: 1,
            runShow: 1,
            rideShow: 1,
            swimShow: 1,
            climbShow: 1,
            marShow: 1,
            sportShow: 1,
            pointNum: 0,
            challengeNum: 0,
            challengeMedal: [],
            stepMedalList: [],
            runMedalList: [],
            rideMedalList: [],
            swimMedalList: [],
            climbMedalList: [],
            marMedalList: [],
            pointsMedalList: [],
            myMedalList: [],
            durationMedalList: [],
            item: {},
            showAnimation: true, // 控制动画的显示
            animationFinished: false, // 动画是否结束的标志
            type: 0, // 0-普通； 1-挑战
            theme: ''
        }
    },
    mounted() {
        if (this.$route.query.token) {
            localStorage.setItem("token", this.$route.query.token);
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
        this.getMyMedalList();
        this.getChallengeMedal();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        getSort(a, b) {
            let medalCategory1 = a.medalCategory;
            let medalCategory2 = b.medalCategory;
            if (medalCategory1 == medalCategory2) {
                return a.medalGrade - b.medalGrade;
            } else {
                if (medalCategory1 == '步行') {
                    medalCategory1 = 0;
                } else if (medalCategory1 == '单日步行') {
                    medalCategory1 = 1;
                } else if (medalCategory1 == '步行达标') {
                    medalCategory1 = 2;
                } else if (medalCategory1 == '持续步行') {
                    medalCategory1 = 3;
                } else if (medalCategory1 == '跑步') {
                    medalCategory1 = 4;
                } else if (medalCategory1 == '单次跑步') {
                    medalCategory1 = 5;
                } else if (medalCategory1 == '持续跑步') {
                    medalCategory1 = 6;
                } else if (medalCategory1 == '骑行') {
                    medalCategory1 = 7;
                } else if (medalCategory1 == '单次骑行') {
                    medalCategory1 = 8;
                } else if (medalCategory1 == '游泳') {
                    medalCategory1 = 9;
                } else if (medalCategory1 == '单次游泳') {
                    medalCategory1 = 10;
                } else if (medalCategory1 == '连续游泳') {
                    medalCategory1 = 11;
                } else if (medalCategory1 == '登山') {
                    medalCategory1 = 12;
                } else if (medalCategory1 == '登山高度') {
                    medalCategory1 = 13;
                } else if (medalCategory1 == '单次登山') {
                    medalCategory1 = 14;
                } else if (medalCategory1 == '马拉松') {
                    medalCategory1 = 15;
                } else if (medalCategory1 == '') {
                    medalCategory1 = 16;
                } else if (medalCategory1 == '积分') {
                    medalCategory1 = 17;
                } else if (medalCategory1 == '运动时长') {
                    medalCategory1 = 18;
                }
                if (medalCategory2 == '步行') {
                    medalCategory2 = 0;
                } else if (medalCategory2 == '单日步行') {
                    medalCategory2 = 1;
                } else if (medalCategory2 == '步行达标') {
                    medalCategory2 = 2;
                } else if (medalCategory2 == '持续步行') {
                    medalCategory2 = 3;
                } else if (medalCategory2 == '跑步') {
                    medalCategory2 = 4;
                } else if (medalCategory2 == '单次跑步') {
                    medalCategory2 = 5;
                } else if (medalCategory2 == '持续跑步') {
                    medalCategory2 = 6;
                } else if (medalCategory2 == '骑行') {
                    medalCategory2 = 7;
                } else if (medalCategory2 == '单次骑行') {
                    medalCategory2 = 8;
                } else if (medalCategory2 == '游泳') {
                    medalCategory2 = 9;
                } else if (medalCategory2 == '单次游泳') {
                    medalCategory2 = 10;
                } else if (medalCategory2 == '连续游泳') {
                    medalCategory2 = 11;
                } else if (medalCategory2 == '登山') {
                    medalCategory2 = 12;
                } else if (medalCategory2 == '登山高度') {
                    medalCategory2 = 13;
                } else if (medalCategory2 == '单次登山') {
                    medalCategory2 = 14;
                } else if (medalCategory2 == '马拉松') {
                    medalCategory2 = 15;
                } else if (medalCategory2 == '') {
                    medalCategory2 = 16;
                } else if (medalCategory2 == '积分') {
                    medalCategory2 = 17;
                } else if (medalCategory2 == '运动时长') {
                    medalCategory2 = 18;
                }
                return medalCategory1 - medalCategory2;
            }
        },
        getMedalList() {
            this.$api.my.getMedalList().then(res => {
                let c = res.info.sort(this.getSort);
                let arrs = [...this.myMedalList, ...c];
                let map = new Map();
                for (let item of arrs) {
                    if (!map.has(item.id)) {
                        map.set(item.id, item)
                    }
                }
                let newArr = [...map.values()];
                newArr = newArr.sort(this.getSort)
                for (let i = 0; i < res.info.length; i++) {
                    let item = newArr[i];
                    if (item.medalCategory == '步行' || item.medalCategory == '单日步行' || item.medalCategory == '步行达标' || item.medalCategory == '持续步行') {
                        this.stepMedalList.push(item);
                    }
                    if (item.medalCategory == '跑步' || item.medalCategory == '单次跑步' || item.medalCategory == '持续跑步') {
                        this.runMedalList.push(item);
                    }
                    if (item.medalCategory == '骑行' || item.medalCategory == '单次骑行') {
                        this.rideMedalList.push(item);
                    }
                    if (item.medalCategory == '游泳' || item.medalCategory == '单次游泳' || item.medalCategory == '连续游泳') {
                        this.swimMedalList.push(item);
                    }
                    if (item.medalCategory == '登山' || item.medalCategory == '登山高度' || item.medalCategory == '单次登山') {
                        this.climbMedalList.push(item);
                    }
                    if (item.medalCategory == '马拉松') {
                        this.marMedalList.push(item);
                    }
                    if (item.medalCategory == '积分') {
                        this.pointsMedalList.push(item);
                    }
                    if (item.medalCategory == '累计运动') {
                        this.durationMedalList.push(item);
                    }
                }
            })
        },
        getMyMedalList() {
            this.$api.my.getMyMedalList().then(res => {
                this.myMedalList = res.info.sort(this.getSort);
                for (let i = 0; i < res.info.length; i++) {
                    let item = this.myMedalList[i];
                    if (item.medalCategory != '积分') {
                        this.sportNum++;
                    }
                    if (item.medalCategory == '积分') {
                        this.pointNum++;
                    }
                }
                this.getMedalList();
            })
        },
        getChallengeMedal() {
            this.$api.my.getChallengeMedal().then(res => {
                this.challengeNum = res.info.length;
                for (let i = 0; i < res.info.length; i++) {
                    let item = res.info[i];
                    let medal = JSON.parse(item.medal);
                    console.log(medal)
                    this.challengeMedal.push({
                        name: item.name,
                        rank: item.rank,
                        url: medal[0].url,
                        attribute: item.attribute,
                        awardTime: item.awardTime
                    })
                }
            })
        },
        // 获取挑战赛名称
        getName(challenge) {
            if (challenge.attribute == 0) {
                return this.$t('challengeType.attribute0.name')
            } else {
                let monthNum = parseInt(challenge.name) - 1;
                let monthDesc = this.$t('monthArr[' + monthNum + ']');
                let name;
                if (challenge.name.indexOf('骑行') != -1) {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '骑行.name');
                } else if (challenge.name.indexOf('跑步') != -1) {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '跑步.name');
                } else {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '.name');
                }
                if (this.$i18n.locale === 'zh') {
                    return monthDesc + name;
                } else {
                    return monthDesc + " " + name;
                }
            }
        },
        toDesc(item) {
            this.item = item
            if (item.awardTime) {
                this.showDesc = 1
                if (item.name) {
                    this.type = 1
                } else {
                    this.type = 0
                }
            } else {
                this.showDescNotGet = 1
            }
        },
        onAnimationEnd() {
            this.animationFinished = true; // 动画结束后，更改标志并显示文本
        },
        closeDesc() {
            this.showDesc = 0;
            this.animationFinished = false;
            this.showDescNotGet = 0;
        }
    }
}
</script>

<style scoped>
/deep/ .van-tab {
    font-size: 15px;
    letter-spacing: 2px;
}

/deep/ .van-tab:nth-child(-n+2):after {
    content: '';
    position: absolute;
    left: auto;
    top: auto;
    bottom: 14px;
    right: 0;
    height: 40%;
    width: 1px;
    background-color: var(--line-color-1);
    opacity: 0.3;
}

.count-box {
    width: 325px;
    height: 47px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 17px auto;
    color: var(--text-color-2);
    font-size: 12px;
    display: flex;
    align-items: center;
    padding-left: 20px;
}

.count-num {
    font-size: 19px;
    color: var(--text-color-1);
    margin: 0 3px;
}

.card {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 12px auto;
    color: var(--text-color-1);
    position: relative;
}

.card-title {
    font-size: 15px;
    padding: 16px 20px;
}

.card-icon {
    position: absolute;
    width: 16px;
    top: 15px;
    right: 20px;
}

.medal-item {
    text-align: center;
    padding-bottom: 20px;
}

.medal-url {
    width: 80px;
    margin-bottom: 3px;
}

.medal-title {
    font-size: 15px;
    text-align: center;
}

.medal-rank-title {
    font-size: 13px;
    text-align: center;
    color: var(--text-color-2);
}

.medal-point-url {
    height: 67px;
}

.content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color-1); /* 半透明背景 */
    z-index: 1000; /* 确保遮罩层在其他内容上方 */
    text-align: center;
}

.medel-img {
    width: 160px;
}

@keyframes scaleDrew {
    0% {
        transform: scale(0.33);
    }

    25% {
        transform: scale(1);
    }

    75% {
        transform: scale(0.8);
    }

    100% {
        transform: scale(1);
    }
}

.animation-box {
    animation: scaleDrew 1s ease-in-out 0s 1 alternate forwards;
    margin-top: 28px;
}

.animate {
    animation-name: scaleDrew;
    animation-duration: 1s;
    animation-fill-mode:  forwards;
}

.name {
    font-size: 25px;
    margin-top: 5px;
    color: var(--text-color-1);
}

.desc {
    font-size: 17px;
    color: var(--text-color-1);
    width: 70%;
    margin: 10px auto;
}

.time {
    font-size: 17px;
    color: var(--text-color-2);
    margin-top: 35px;
    margin-bottom: 30px;
}

.text-fade-in {
    opacity: 0; /* 初始状态隐藏 */
    animation: fadeIn 1s ease-in-out 0s 1 alternate forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.no-data-text {
    color: var(--text-color-2);
    font-size: 16px;
    text-align: center;
    padding-bottom: 30px;
}

.close {
    margin-top: 30px;
}

.c {
    padding-top: 88px;
}
</style>



// WEBPACK FOOTER //
// src/views/my/02medal.vue